/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guestlist_AudienceInputs */

const en_guestlist_audience = /** @type {(inputs: Guestlist_AudienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For sales and marketing`)
};

/**
* | output |
* | --- |
* | "For sales and marketing" |
*
* @param {Guestlist_AudienceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const guestlist_audience = /** @type {((inputs?: Guestlist_AudienceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guestlist_AudienceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_guestlist_audience(inputs)
});